// extracted by mini-css-extract-plugin
export var addToCartButton = "_uf-b";
export var arrowButtonContainer = "_uf-9";
export var arrowButtonIcon = "_uf-a";
export var carouselArrowButton = "_uf-6";
export var carouselElementContainer = "_uf-1";
export var left = "_uf-7";
export var productDisplayCarouselContainer = "_uf-0";
export var productTileContainer = "_uf-2";
export var productTileImage = "_uf-4";
export var productTileImageContainer = "_uf-3";
export var productTileTitle = "_uf-5";
export var right = "_uf-8";
export var sliderOverflow = "_uf-c";